import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
  return (
    <div className="bg-violet-1000 px-10 py-16 text-white flex flex-col lg:flex-row ">
      <div className="flex-grow flex-shrink-0 w-full lg:w-1/6">
        <div className="font-bold text-lg py-4">Free Tools</div>
        <ul className=" footer-list">
          <li>Dugout</li>
          <li>Assistant Manager</li>
          <li>Price Change Predictor</li>
          <li>Transfer Trends</li>
          <li>Gameweek Live</li>
          <li>Match Stats</li>
          <li>Player Performance Report</li>
          <li>Injuries &amp; Suspensions</li>
        </ul>
      </div>

      <div className="flex-grow flex-shrink-0 w-full lg:w-1/6">
        <div className="font-bold text-lg py-4">Premium Tools</div>
        <ul className="footer-list">
          <li>Mini-League Optimiser</li>
          <li>Predicted Points and Stats</li>
          <li>Squad Rotation Planner</li>
          <li>Fixture Analyser</li>
          <li>Predicted Lineups</li>
          <li>Player Heatmaps</li>
          <li>Custom Stats Builder</li>
          <li>Fix Comparison Matrix</li>
          <li>FPL Statistics</li>
          <li>Fix Rivals</li>
          <li>Rank Prediction Machine</li>
        </ul>
      </div>

      <div className="flex-grow flex-shrink-0 ">
        <div className="font-bold text-lg py-4">Free Fix Apps</div>
        <ul className="footer-list">
          <li  className="text-center bg-opacity-30 hover:bg-opacity-40 text-lg bg-gray-500 px-3 lg:px-6 py-3 mb-3 mr-6">
              <FontAwesomeIcon icon={['fab', 'apple']} />
            <a href="/#"> App Store </a>
          </li>
          <li className="text-center bg-opacity-30 hover:bg-opacity-40 text-lg bg-gray-500 px-3 lg:px-6 py-3 mb-3 mr-6">
          <FontAwesomeIcon icon={['fab', 'google-play']}  />
            <a href="/#"> <span className="font-serif">Google</span> play </a>
          </li>
        </ul>
      </div>

      <div className="flex-grow flex-shrink-0 w-full lg:w-1/6">
        <div className="font-bold text-lg py-4">My Fix</div>
        <ul className="footer-list">
          {" "}
          <li>Mini-League Optimiser</li>
          <li>Predicted Points and Stats</li>
          <li>Squad Rotation Planner</li>
          <li>Fixture Analyser</li>
          <li>Predicted Lineups</li>
          <li>Player Heatmaps</li>
          <li>Custom Stats Builder</li>
          <li>Fix Comparison Matrix</li>
          <li>FPL Statistics</li>
          <li>Fix Rivals</li>
          <li>Rank Prediction Machine</li>
        </ul>
      </div>

      <div className="flex-grow flex-shrink-0 w-full lg:w-1/6">
        <div className="font-bold text-lg py-4">Social</div>
        <ul className="footer-list">
          <li><FontAwesomeIcon icon={['fab', 'facebook']}/> Facebook</li>
          <li><FontAwesomeIcon icon={['fab', 'twitter']}/>  Twitter</li>
          <li><FontAwesomeIcon icon={['fab', 'youtube']}/>  YouTube</li>
          <li><FontAwesomeIcon icon={['fab', 'instagram']}/> Instagram</li>
        </ul>
      </div>

      <div className="flex-grow flex-shrink-0 w-full lg:w-1/6">
        <div className="font-bold text-lg py-4">Corporate</div>
        <ul className="footer-list">
          <li>Advertising on fix</li>
          <li>Licence our Projections</li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
